import { Navigate, Route, Routes } from 'react-router-dom'
import redirects from 'constants/redirects'
import ConnFailed from 'pages/ConnFailed/ConnFailed'
import NoAthorized from 'pages/NoAuthorized/NoAthorized'
import OnLoadError from 'pages/OnLoadError/OnLoadError'
import OutdatedBrowser from 'pages/OutdatedBrowser/OutdatedBrowser'
import PageNotFound from 'pages/PageNotFound/PageNotFound'
import UnsuportedBrowser from 'pages/UnsuportedBrowser/UnsuportedBrowser'

import { Redirect } from 'components'

export function CustomRoutes() {
  return (
    <Routes>
      <Route path="erro/nao-encontrado" element={<PageNotFound />}></Route>
      <Route path="erro/nao-autorizado" element={<NoAthorized />}></Route>
      <Route path="erro/erro-de-conexao" element={<ConnFailed />}></Route>
      <Route
        path="erro/navegador-nao-suportado"
        element={<UnsuportedBrowser />}
      />
      <Route
        path="erro/navegador-desatualizado"
        element={<OutdatedBrowser />}
      />
      <Route path="erro/erro-ao-carregar" element={<OnLoadError />} />
      {redirects.map((redirect) => (
        <Route
          key={redirect.from}
          path={redirect.from}
          element={<Redirect url={redirect.to} />}
        ></Route>
      ))}
      <Route
        path="*"
        element={<Navigate to="erro/nao-encontrado" replace={true} />}
      ></Route>
    </Routes>
  )
}
